import { render, staticRenderFns } from "./HonourCard.vue?vue&type=template&id=272ba380&scoped=true"
import script from "./HonourCard.vue?vue&type=script&lang=js"
export * from "./HonourCard.vue?vue&type=script&lang=js"
import style0 from "./HonourCard.vue?vue&type=style&index=0&id=272ba380&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272ba380",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('272ba380')) {
      api.createRecord('272ba380', component.options)
    } else {
      api.reload('272ba380', component.options)
    }
    module.hot.accept("./HonourCard.vue?vue&type=template&id=272ba380&scoped=true", function () {
      api.rerender('272ba380', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/aboutUS/components/HonourCard.vue"
export default component.exports